/**
 * Authenticated API client for admin dashboard
 * Automatically includes JWT token in Authorization header
 */
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

// Create axios instance with auth interceptor
const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

// Request interceptor - add JWT token to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('vpp_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - clear auth and redirect to login
      localStorage.removeItem('vpp_token');
      localStorage.removeItem('vpp_user');
      // Don't redirect here - let the component handle it
    }
    return Promise.reject(error);
  }
);

export default api;
export { API_BASE };
